import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default function config() {
  // 客户信息
  const m_customerInfo = [
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'rentCalculationRules',
        value: '企业客户',
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '选择租赁方案',
        prop: 'planId',
      },
      elConfig: {
        options: {
          label: 'name',
          value: 'id',
          list: [],
        },
        events: {
          change: this.planChange,
        },
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '上架单ID',
        prop: 'planRecordId',
      },
    },
  ]
  const m_customerInfoModel = {}

  // 车辆选择
  const m_addVehicle = [
    {
      el: 'CarBrandSeriesModel',
      itemConfig: {
        prop: 'brandSeriesModel',
      },
      elConfig: {
        showModel: true,
        disabled: false,
        brandSeriesModelName: {},
        filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
      },
      render: 'CarBrandSeriesModel',
    },
    {
      el: 'select',
      itemConfig: {
        label: '添加车辆',
        prop: 'plateNo',
      },
      elConfig: {
        clearable: true,
        filterable: true,
        options: {
          label: 'plateNo',
          value: 'id',
          list: [],
        },
      },
    },
  ]
  const m_addVehicleModel = {}
  return {
    // 客户信息
    m_customerInfo,
    m_customerInfoModel,
    // 车辆选择
    m_addVehicle,
    m_addVehicleModel,
  }
}
